import { useMemo } from 'react';
import { sortBy } from 'lodash/fp';
import { BusinessSegment } from '@mews-commander/data-access';
import { getServiceBusinessSegments } from '@mews-commander/legacy-entities/src/ducks/businessSegments';
import { createOption } from '@mews-commander/ui';
import { useCommanderSelector } from '@mews-commander/utils';

export const useBusinessSegmentOptions = (serviceId: string) => {
    const businessSegments = useCommanderSelector((state) =>
        getServiceBusinessSegments(state, { serviceId })
    ) as BusinessSegment[];

    return useMemo(
        () => sortBy('name', businessSegments).map(({ id, name }) => createOption({ value: id, label: name })),
        [businessSegments]
    );
};
